module.exports = __webpack_public_path__ + "static/img/banner.e49ce2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/banner.png
// module id = oCIs
// module chunks = 0